// extracted by mini-css-extract-plugin
module.exports = {"avatarGroup":"AvatarGroup_avatarGroup__QLPv6","avatarItem":"AvatarGroup_avatarItem__URi0T","defaultAvatar":"AvatarGroup_defaultAvatar__S_MLR"};